import React, { useCallback, useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import ArchetypeCollectibleCard from "./ArchetypeCollectibleCard";

import RulerImg from "../../images/RulerImg.png";
import CaregiverImg from "../../images/CaregiverImg.png";
import CreatorImg from "../../images/CreatorImg.png";
import LoverImg from "../../images/LoverImg.png";
import JokerImg from "../../images/JokerImg.png";
import EverymanImg from "../../images/EverymanImg.png";
import HeroImg from "../../images/HeroImg.png";
import MagicianImg from "../../images/MagicianImg.png";
import RebelImg from "../../images/RebelImg.png";
import ExplorerImg from "../../images/ExplorerImg.png";
import SageImg from "../../images/SageImg.png";
import InnocentImg from "../../images/InnocentImg.png";
import ClerkSprite from "../../images/IMG_2169.png";

const ARCHETYPES_API_URL =
  "https://us-central1-archetype-builder-api.cloudfunctions.net/api/archetypes/";

export const ARCHETYPE_STOCK = [
  { src: CaregiverImg, name: "Caregiver", line: "Caregiver card — flip it for the live API profile." },
  { src: RulerImg, name: "Ruler", line: "Ruler card — flip it for the live API profile." },
  { src: CreatorImg, name: "Creator", line: "Creator card — flip it for the live API profile." },
  { src: LoverImg, name: "Lover", line: "Lover card — flip it for the live API profile." },
  { src: JokerImg, name: "Joker", line: "Joker card — flip it for the live API profile." },
  { src: EverymanImg, name: "Everyman", line: "Everyman card — flip it for the live API profile." },
  { src: HeroImg, name: "Hero", line: "Hero card — flip it for the live API profile." },
  { src: MagicianImg, name: "Magician", line: "Magician card — flip it for the live API profile." },
  { src: RebelImg, name: "Rebel", line: "Rebel card — flip it for the live API profile." },
  { src: ExplorerImg, name: "Explorer", line: "Explorer card — flip it for the live API profile." },
  { src: SageImg, name: "Sage", line: "Sage card — flip it for the live API profile." },
  { src: InnocentImg, name: "Innocent", line: "Innocent card — flip it for the live API profile." },
];

const WELCOME =
  "Welcome to The Future Store. Flip an archetype card to read its live API JSON — same data as the Academy.";

export default function ArchetypeStockShelf() {
  const [dialogue, setDialogue] = useState(WELCOME);
  const [activeName, setActiveName] = useState(null);
  const [flippedCard, setFlippedCard] = useState(null);
  const [apiByName, setApiByName] = useState({});
  const [apiStatus, setApiStatus] = useState("loading");

  const loadArchetypes = useCallback(async () => {
    setApiStatus("loading");
    try {
      const response = await fetch(ARCHETYPES_API_URL);
      if (!response.ok) {
        throw new Error(`API ${response.status}`);
      }
      const data = await response.json();
      if (!Array.isArray(data)) {
        throw new Error("Unexpected API payload");
      }
      const byName = data.reduce((acc, archetype) => {
        const key = String(archetype?.name || "").trim().toLowerCase();
        if (key) acc[key] = archetype;
        return acc;
      }, {});
      setApiByName(byName);
      setApiStatus("ready");
    } catch (err) {
      setApiByName({});
      setApiStatus("error");
    }
  }, []);

  useEffect(() => {
    loadArchetypes();
  }, [loadArchetypes]);

  const flipCard = (item) => {
    const next = flippedCard === item.name ? null : item.name;
    setFlippedCard(next);
    setActiveName(item.name);
    if (next) {
      const motto = apiByName[item.name.toLowerCase()]?.motto;
      setDialogue(
        motto
          ? `${item.name} flipped. Motto: "${motto}" — scroll the reverse for full GET /api/archetypes/ JSON.`
          : `${item.name} flipped. Live Archetype API payload is on the reverse.`
      );
    } else {
      setDialogue("Card face up again. Flip another collectible whenever you're ready.");
    }
  };

  return (
    <ShopFloor>
      <BackWall>
        <ShelfLabel>ARCHETYPE STOCK · COLLECTIBLE CARDS</ShelfLabel>
        <ShelfGrid>
          {ARCHETYPE_STOCK.map((item) => (
            <ArchetypeCollectibleCard
              key={item.name}
              item={item}
              json={apiByName[item.name.toLowerCase()] || null}
              apiStatus={apiStatus}
              flipped={flippedCard === item.name}
              onFlip={() => flipCard(item)}
            />
          ))}
        </ShelfGrid>
      </BackWall>

      {/* <FloorPerspective />

      <Counter>
        <CounterTop />
        <ClerkZone>
          <ClerkWrap>
            <ClerkImg src={ClerkSprite} alt="Store clerk" />
            <ClerkName>2FLY</ClerkName>
          </ClerkWrap>
          <DialogueBox>
            <DialogueHeader>
              <span>SHOPKEEP</span>
              {activeName ? <span>VIEWING: {activeName}</span> : <span>READY</span>}
            </DialogueHeader>
            <DialogueText key={dialogue}>{dialogue}</DialogueText>
            <DialogueHint>Flip a collectible card · same JSON as Archetype Academy</DialogueHint>
          </DialogueBox>
        </ClerkZone>
      </Counter> */}
    </ShopFloor>
  );
}

const bob = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
`;

const typeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
`;

const ShopFloor = styled.div`
  position: relative;
  z-index: 2;
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
`;

const BackWall = styled.div`
  flex: 1;
  padding: 0.5rem 0.5rem 1.5rem;
  border: 1px solid rgba(69, 254, 71, 0.22);
  border-bottom: none;
  background: transparent;
  box-shadow: inset 0 0 60px rgba(0, 0, 0, 0.15);
`;

const ShelfLabel = styled.div`
  font-family: "VT323", monospace;
  font-size: 1.15rem;
  letter-spacing: 0.2em;
  color: rgba(69, 254, 71, 0.75);
  margin: 0.25rem 0 0.75rem 0.35rem;
`;

const ShelfGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0.85rem;

  @media (max-width: 900px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  @media (max-width: 560px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.65rem;
  }
`;

const FloorPerspective = styled.div`
  height: 48px;
  background: linear-gradient(
    180deg,
    rgba(69, 254, 71, 0.08),
    transparent
  );
  border-left: 1px solid rgba(69, 254, 71, 0.18);
  border-right: 1px solid rgba(69, 254, 71, 0.18);
  transform: perspective(400px) rotateX(28deg);
  transform-origin: top;
  margin: 0 4px -8px;
`;

const Counter = styled.div`
  position: relative;
  z-index: 3;
  margin-top: auto;
`;

const CounterTop = styled.div`
  height: 14px;
  background: linear-gradient(
    180deg,
    #1a3320,
    #0c1810 40%,
    #45fe47 42%,
    #0c1810 48%,
    #15261a
  );
  border: 1px solid rgba(69, 254, 71, 0.45);
  box-shadow: 0 -8px 24px rgba(69, 254, 71, 0.15);
`;

const ClerkZone = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 0.75rem;
  align-items: end;
  padding: 0.75rem 0.85rem 1.1rem;
  background: linear-gradient(
    135deg,
    rgba(8, 24, 14, 0.45),
    rgba(0, 0, 0, 0.28) 55%,
    rgba(8, 20, 12, 0.4)
  );
  backdrop-filter: blur(14px) saturate(1.2);
  -webkit-backdrop-filter: blur(14px) saturate(1.2);
  border: 1px solid rgba(69, 254, 71, 0.28);
  border-top: none;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);

  @media (max-width: 768px) {
    grid-template-columns: 96px 1fr;
    align-items: stretch;
    gap: 0.5rem;
    padding: 0.65rem 0.55rem 0.9rem;
  }
`;

const ClerkWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${bob} 2.8s ease-in-out infinite;

  @media (max-width: 768px) {
    height: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
    animation: none;
  }
`;

const ClerkImg = styled.img`
  width: 100%;
  max-width: 120px;
  height: auto;
  image-rendering: auto;
  filter: drop-shadow(0 0 12px rgba(69, 254, 71, 0.35));
`;

const ClerkName = styled.div`
  margin-top: 0.2rem;
  font-family: "VT323", monospace;
  font-size: 1rem;
  letter-spacing: 0.18em;
  color: #45fe47;
`;

const DialogueBox = styled.div`
  border: 2px solid rgba(69, 254, 71, 0.75);
  background: rgba(0, 0, 0, 0.38);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 0.55rem 0.75rem 0.65rem;
  min-height: 110px;
  box-shadow:
    inset 0 0 0 1px rgba(69, 254, 71, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
`;

const DialogueHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  font-family: "VT323", monospace;
  font-size: 0.95rem;
  letter-spacing: 0.12em;
  color: rgba(69, 254, 71, 0.8);
  margin-bottom: 0.35rem;
  border-bottom: 1px solid rgba(69, 254, 71, 0.25);
  padding-bottom: 0.25rem;
`;

const DialogueText = styled.p`
  margin: 0;
  font-family: "VT323", monospace;
  font-size: clamp(1.15rem, 2.4vw, 1.45rem);
  line-height: 1.25;
  color: #f2fff2;
  animation: ${typeIn} 0.28s ease;
`;

const DialogueHint = styled.div`
  margin-top: 0.45rem;
  font-family: "VT323", monospace;
  font-size: 0.9rem;
  letter-spacing: 0.08em;
  color: rgba(157, 255, 159, 0.55);
`;
